import request from './request'

export function listProductionLine(data) {
  return request.post('/mes/production-lines/list', data)
}
export function selectProductionLine() {
  return request.get('/mes/production-lines/select')
}
export function getProductionLine(id) {
  return request.get('/mes/production-lines/' + id)
}
export function saveProductionLine(data) {
  return request.post('/mes/production-lines', data)
}
export function updateProductionLine(data) {
  return request.post('/mes/production-lines/update', data)
}
export function deleteProductionLine(ids) {
  return request.post('/mes/production-lines/delete', ids)
}
